import React, { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../Services/AuthService';

function Logout() {
    const dispatch = useDispatch();
    const white_label = useSelector((state) => state.auth.white_label)||sessionStorage.getItem('white_label');
    
    const shouldLoginWithSSO = (() => {
      try {
        const miscProperties = white_label?.data?.miscProperties || white_label?.miscProperties;
        if (miscProperties) {
          const parsed = typeof miscProperties === 'string' ? JSON.parse(miscProperties) : miscProperties;
          return parsed.shouldLoginWithSSO || false;
        }
        return false;
      } catch (e) {
        return false;
      }
    })();
    
    useEffect(() => {
        logout(dispatch, shouldLoginWithSSO)
    }, [shouldLoginWithSSO, dispatch])
    return (
        <Fragment></Fragment>
    )
}

export default Logout
